module.exports = __webpack_public_path__ + "static/media/failed_icon.fea0b28a.svg";